module.exports = __webpack_public_path__ + "static/media/entrance.564c810a.jpg";